import { ReactElement } from 'react';

export interface ExtendableComponent<T> {
  component?: (props: T) => ReactElement;
  props: T;
}

export interface ExtendableElement<T> {
  element?: ReactElement;
  props?: T;
}

export type ModeType =
  | 'default'
  | 'default-alt'
  | 'inverse'
  | 'inverse-alt'
  | 'transparent'
  | string;

export type SpacingVariant = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;

export type JustifyContentType =
  | 'start'
  | 'end'
  | 'center'
  | 'between'
  | 'around';

export type AlignItemsType =
  | 'start'
  | 'end'
  | 'center'
  | 'baseline'
  | 'stretch';

export type AlignContentType =
  | 'start'
  | 'end'
  | 'center'
  | 'between'
  | 'around'
  | 'stretch';

export enum ContentDirection {
  LTR = 'ltr',
  RTL = 'rtl',
}

export const modeArgType = {
  options: ['default', 'default-alt', 'inverse', 'inverse-alt', 'transparent'],
  control: 'select',
};
